<template>
  <b-modal
    :id="modalId"
    title="Tambah Konser Penjualan"
    no-close-on-backdrop
    no-close-on-esc
    hide-footer
    size="lg"
    @hidden="onHidden"
  >
    <b-form-group>
      <template #label>Nama Konser <span class="text-danger">*</span></template>
      <b-form-input
        v-model="form.name"
        maxlength="150"
        placeholder="Masukkan nama konser"
      />
    </b-form-group>
    <b-row>
      <b-col md="6">
        <b-form-group>
          <template #label>Tanggal Pendaftaran <span class="text-danger">*</span></template>
          <b-form-input v-model="form.submission_at" type="datetime-local" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <template #label>Tanggal Konser <span class="text-danger">*</span></template>
          <b-form-input v-model="form.date" type="date" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group>
      <template #label>Cabang/Kantor <span class="text-danger">*</span></template>
      <multiselect
        v-model="form.office"
        label="name"
        track-by="id"
        :internal-search="true"
        deselect-label=""
        select-label=""
        placeholder="Pilih cabang/kantor"
        :options="optOffices"
      />
    </b-form-group>
    <b-row>
      <b-col md="6">
        <b-form-group>
          <template #label>Jumlah Kuota <span class="text-danger">*</span></template>
          <b-form-input
            v-model="form.max_quota"
            type="number"
            min="1"
            placeholder="Contoh: 100"
          />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <template #label>Slot per Pedagang <span class="text-danger">*</span></template>
          <b-form-input
            v-model="form.max_slot"
            type="number"
            min="1"
            placeholder="Contoh: 2"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group>
      <template #label>Maks. Orang Hadir <span class="text-danger">*</span></template>
      <b-form-input
        v-model="form.attending_count"
        type="number"
        min="1"
        max="5"
        placeholder="Contoh: 1"
      />
    </b-form-group>
    <b-form-group>
      <template #label>Wajib Down Payment</template>
      <b-form-checkbox v-model="form.require_down_payment" switch>
        {{ form.require_down_payment ? "Ya" : "Tidak" }}
      </b-form-checkbox>
    </b-form-group>
    <div class="mt-4 text-right">
      <b-button variant="primary" :disabled="isSubmitting" @click="confirmSave">
        {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ModalKonserPenjualan",
  props: {
    modalId: {
      type: String,
      default: "m-form-konser"
    },
    optOffices: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isSubmitting: false,
      form: {
        name: "",
        submission_at: "",
        date: "",
        office: null,
        max_slot: null,
        max_quota: null,
        attending_count: null,
        require_down_payment: true
      }
    };
  },
  methods: {
    openModal() {
      this.form = {
        name: "",
        submission_at: "",
        date: "",
        office: null,
        max_slot: null,
        max_quota: null,
        attending_count: null,
        require_down_payment: true
      };
      this.$bvModal.show(this.modalId);
    },

    onHidden() {
      this.form = {
        name: "",
        submission_at: "",
        date: "",
        office: null,
        max_slot: null,
        max_quota: null,
        attending_count: null,
        require_down_payment: true
      };
    },

    confirmSave() {
      if (this.$helper.isBlank(this.form.name)) {
        return this.$helper.toastError(this, "Nama konser tidak boleh kosong!");
      }
      if (this.$helper.isBlank(this.form.submission_at)) {
        return this.$helper.toastError(
          this,
          "Tanggal pendaftaran tidak boleh kosong!"
        );
      }
      if (this.$helper.isBlank(this.form.date)) {
        return this.$helper.toastError(
          this,
          "Tanggal konser tidak boleh kosong!"
        );
      }
      if (this.form.date < this.form.submission_at.substring(0, 10)) {
        return this.$helper.toastError(
          this,
          "Tanggal konser tidak boleh lebih awal dari tanggal pendaftaran!"
        );
      }

      if (this.form.office == null) {
        return this.$helper.toastError(
          this,
          "Cabang/Kantor tidak boleh kosong!"
        );
      }
      if (!this.form.max_quota || this.form.max_quota < 1) {
        return this.$helper.toastError(
          this,
          "Jumlah kuota tidak boleh kosong!"
        );
      }
      if (!this.form.attending_count || this.form.attending_count < 1) {
        return this.$helper.toastError(
          this,
          "Maks. orang hadir tidak boleh kosong!"
        );
      }
      if (this.form.attending_count > 5) {
        return this.$helper.toastError(
          this,
          "Maks. orang hadir tidak boleh lebih dari 5!"
        );
      }

      let isConfirmed = confirm(
        "Simpan konser penjualan baru ini? Pastikan semua data sudah benar."
      );
      if (!isConfirmed) return;

      let submissionAtStr = this.form.submission_at;
      if (submissionAtStr && submissionAtStr.includes("T")) {
        submissionAtStr = submissionAtStr.replace("T", " ") + ":00";
      }

      let payload = {
        name: this.form.name,
        submission_at: submissionAtStr,
        date: this.form.date,
        office_id: this.form.office.id,
        max_slot: this.form.max_slot ? parseInt(this.form.max_slot) : null,
        max_quota: parseInt(this.form.max_quota),
        attending_count: parseInt(this.form.attending_count),
        require_down_payment: this.form.require_down_payment
      };

      this.isSubmitting = true;

      const request = this.$axios.post("concerts", payload);

      request
        .then(() => {
          this.$helper.toastSuccess(
            this,
            "Konser penjualan baru berhasil ditambahkan!"
          );
          this.$bvModal.hide(this.modalId);
          this.$emit("refresh");
        })
        .catch(error => this.$helper.parseError(this, error))
        .finally(() => (this.isSubmitting = false));
    },

  }
};
</script>
